// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.user-info {
  width: 280px;
  padding: 27px 32px;
  background-color: #e1eefe;
}

.device i-feather[name=more-vertical] {
  color: #8291ae;
  float: right;
}

.device-active i-feather[name=Smartphone] {
  color: #1ba953;
}

.device-inactive i-feather[name=Smartphone] {
  color: #f64540;
}

.device-inactive {
  color: #8291ae;
}

.main-container {
  padding: 27px 27px 0;
}

.device-status {
  font-weight: bold;
}

.device-status.NotActivated {
  color: #f64540;
}

.device-status.Pending {
  color: #ff612c;
}

.device-status.Activated {
  color: #1ba953;
}

.device-status.Deactivated {
  color: #f64540;
}

.device-pin {
  margin-left: 24px;
  margin-top: -14px;
}

.device-imei {
  margin-top: -4px;
}

.pending-device {
  min-height: 30px;
}

.pending-devices {
  background: #fff4cb;
  border-radius: 4px;
  padding-bottom: 1px;
  margin-bottom: 5px;
}

.device-warning {
  padding: 19px 14px;
  border-radius: 4px;
  margin-bottom: 27px;
}

.device-warning.NotActivated {
  color: #a94442;
  border: solid 1px #ffe3e2;
  background-color: #ffe3e2;
}

.device-warning.Pending {
  color: #8a6d3b;
  border: solid 1px #fff4cb;
  background-color: #fcf8e3;
}

::ng-deep .seperator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
::ng-deep .profile-box {
  display: block;
  min-height: 461px;
  margin-bottom: 30px;
  background-color: #fff;
}
::ng-deep .box-icon {
  width: 40px;
  height: 40px;
  color: #8291ae;
}
::ng-deep .box-icon::ng-deep svg {
  stroke-width: 1px;
}
::ng-deep .box-text {
  color: #8291ae;
}
::ng-deep .box-filler {
  height: 38.5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/users/user-view/user-view.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC9LA;EACE,YAAA;EACA,kBAAA;EACA,yBDOe;ACKjB;;AATA;EACE,cDKS;ECJT,YAAA;AAYF;;AATA;EACE,cDOU;ACKZ;;AATA;EACE,cDeQ;ACHV;;AATA;EACE,cDRS;ACoBX;;AATA;EACE,oBAAA;AAYF;;AATA;EACE,iBAAA;AAYF;;AATA;EACE,cDDQ;ACaV;;AATA;EACE,cDNW;ACkBb;;AATA;EACE,cDrBU;ACiCZ;;AATA;EACE,cDbQ;ACyBV;;AATA;EACE,iBAAA;EACA,iBAAA;AAYF;;AATA;EACE,gBAAA;AAYF;;AATA;EACE,gBAAA;AAYF;;AATA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAYF;;AATA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAYF;;AATA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAYF;;AATA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAYF;;AARE;EACE,6CAAA;AAWJ;AARE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AAUJ;AAPE;EACE,WAAA;EACA,YAAA;EACA,cDxFO;ACiGX;AALI;EACE,iBAAA;AAON;AAFE;EACE,cDnGO;ACuGX;AADE;EACE,cAAA;AAGJ","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../styles/variables\";\n\n.user-info {\n  width: 280px;\n  padding: 27px 32px;\n  background-color: $fms-blue-light;\n}\n\n.device i-feather[name=\"more-vertical\"] {\n  color: $fms-gray;\n  float: right;\n}\n\n.device-active i-feather[name=\"Smartphone\"]{\n  color: $fms-green\n}\n\n.device-inactive i-feather[name=\"Smartphone\"] {\n  color: $fms-red\n}\n\n.device-inactive {\n  color: $fms-gray;\n}\n\n.main-container {\n  padding: 27px 27px 0;\n}\n\n.device-status {\n  font-weight: bold;\n}\n\n.device-status.NotActivated {\n  color: $fms-red;\n}\n\n.device-status.Pending {\n  color: $fms-orange;\n}\n\n.device-status.Activated {\n  color: $fms-green;\n}\n\n.device-status.Deactivated {\n  color: $fms-red;\n}\n\n.device-pin {\n  margin-left: 24px;\n  margin-top: -14px;\n}\n\n.device-imei {\n  margin-top: -4px;\n}\n\n.pending-device {\n  min-height: 30px;\n}\n\n.pending-devices {\n  background: #fff4cb;\n  border-radius: 4px;\n  padding-bottom: 1px;\n  margin-bottom: 5px;\n}\n\n.device-warning {\n  padding: 19px 14px;\n  border-radius: 4px;\n  margin-bottom: 27px;\n}\n\n.device-warning.NotActivated {\n  color: #a94442;\n  border: solid 1px #ffe3e2;\n  background-color: #ffe3e2;\n}\n\n.device-warning.Pending {\n  color: #8a6d3b;\n  border: solid 1px #fff4cb;\n  background-color: #fcf8e3;\n}\n\n::ng-deep {\n  .seperator {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  }\n\n  .profile-box {\n    display: block;\n    min-height: 461px;\n    margin-bottom: 30px;\n    background-color: #fff;\n  }\n\n  .box-icon {\n    width: 40px;\n    height: 40px;\n    color: $fms-gray;\n  }\n\n  .box-icon::ng-deep {\n    svg {\n      stroke-width: 1px;\n    }\n  }\n\n\n  .box-text {\n    color: $fms-gray;\n  }\n\n  .box-filler {\n    height: 38.5px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
